"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UndefinedModelDefinition = exports.ModelDefinition = exports.LegacyModelDefinition = exports.LocalModelDefinition = exports.ModelDefinitionType = void 0;
var ModelDefinitionType;
(function (ModelDefinitionType) {
    ModelDefinitionType[ModelDefinitionType["Undefined"] = 0] = "Undefined";
    ModelDefinitionType[ModelDefinitionType["Local"] = 1] = "Local";
    ModelDefinitionType[ModelDefinitionType["PlatformLegacy"] = 2] = "PlatformLegacy";
    ModelDefinitionType[ModelDefinitionType["Platform"] = 3] = "Platform";
})(ModelDefinitionType = exports.ModelDefinitionType || (exports.ModelDefinitionType = {}));
/**
 * Shim to support local-only streaming workflow.
 */
class LocalModelDefinition {
    constructor(targetUri) {
        this.id = '';
        this.type = ModelDefinitionType.Local;
        this.targetUri = targetUri;
    }
}
exports.LocalModelDefinition = LocalModelDefinition;
/**
 * Legacy (Reality) platform based models.
 */
class LegacyModelDefinition {
    constructor(targetUri, appName, key, secret) {
        this.targetUri = targetUri;
        this.appName = appName;
        this.key = key;
        this.secret = secret;
        this.type = ModelDefinitionType.PlatformLegacy;
    }
}
exports.LegacyModelDefinition = LegacyModelDefinition;
/**
 * Model definition for (new) launch requests for models uploaded through the developer console.
 */
class ModelDefinition {
    constructor() {
        this.type = ModelDefinitionType.Platform;
    }
}
exports.ModelDefinition = ModelDefinition;
class UndefinedModelDefinition extends ModelDefinition {
    constructor() {
        super();
        this.type = ModelDefinitionType.Undefined;
    }
}
exports.UndefinedModelDefinition = UndefinedModelDefinition;
//# sourceMappingURL=ModelDefinition.js.map